module.exports = __webpack_public_path__ + "static/glasschale-weiß_blau.432044fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/glasschale-weiß_blau.jpg
// module id = 557
// module chunks = 35783957827783